// Nav-rail feed for the top-level Dashboards section: the org's AI-managed
// dashboards, each rendered as its own rail item under the section label.
// Polled on its own (like useInboxPendingCount) because the rail is mounted
// on every page — 30s is plenty for a list agents mutate a few times an hour.
import { useClient } from '@cortex/react-query';
import type { DashboardListItem } from '@cortex/types';
import { useQuery } from '@tanstack/react-query';

const pollIntervalMs = 30_000;
const navListCap = 25;

export function useNavDashboards(): DashboardListItem[] {
  const client = useClient();
  const list = useQuery({
    queryKey: ['nav', 'dashboards'],
    queryFn: () =>
      client.http
        .get('v1/dashboards', { searchParams: { limit: String(navListCap) } })
        .json<{ items: DashboardListItem[] }>(),
    refetchInterval: pollIntervalMs,
  });
  return list.data?.items ?? [];
}
